/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BotLogoOut } from './botLogoOut';
import type { BotTileOut } from './botTileOut';
import type { EffectiveBrandingOut } from './effectiveBrandingOut';

export interface OrgBrandingOut {
  bot_name?: string | null;
  tile?: BotTileOut | null;
  logo?: BotLogoOut | null;
  effective: EffectiveBrandingOut;
  refresh_started: boolean;
}
